/* eslint-disable */
/**
 * 获取两个数组的交集
 * @param  {Array}  arr1 [description]
 * @param  {Array}  arr2 [description]
 * @return {Array}      [description]
 */
function intersect(arr1 = [], arr2 = []) {
  return arr1.filter(item => arr2.includes(item))
}

/**
 * 根据规格项和规格值格式化规格数据，得到一个关于规格项的二维数组
 * 形如：[[{specId, specName, specItemId, specItemName}]]
 * @param  {[type]} specs     [description]
 * @param  {[type]} specItems [description]
 * @return {[type]}           [description]
 */
function formatSpecData(specIds, specItems, specNames) {
  return specIds.map(specId => {
    return specItems[specId].map((specItem, index) => {
      return {
        specId,
        specName: specNames[specId],
        specItemId: index + 1 + '',
        specItemName: specItem.name
      }
    })
  })
}

/**
 * 遍历选中规格值，在已选某个规格值的情况下，别的规格项有哪些可选项，依次根据已选规格值取可选规格值数组的交集
 * @param {Array} checkedSpecItemIds 用户选中的规格值数组，与规格项顺序一致，没选择则为‘’，形如['1', '', '1']
 * @param {Array} skus               sku列表
 * @param {Array} specIds            规格Id列表，形如["0", "1"]，提供所有可能的规格Id，确定规格展现顺序
 * @param {Object} specItems         规格值对象，以规格Id作为key，所有可能的规格值数组为value，规格值Id为数组index + 1
 * 形如{0: [{name: "全网通版 6G+64G", value: "", valueExt: ""}, {name: "全网通版 6G+128G", value: "", valueExt: ""},…]
 * @param {Object} specNames         规格名称，形如{0: "版本", 1: "颜色的"}
 * @param {Object} isAftServiceGoods  是否是售后服务商品
 */
function getAvaiSpecs(checkedSpecItemIds = [], skus = [], specIds, specItems, specNames, isAftServiceGoods=false) {
  if(isAftServiceGoods) return getAftAvaiServiceSpec({checkedSpecItemIds, skus, specIds})
  const specData = formatSpecData(specIds, specItems, specNames)
  // 根据格式化后的数据获得初始状态下的可选规格值数组
  let avaiSpecs = specData.map(specItems => specItems.map(specItem => specItem.specItemId))

  // 根据所有sku，获得每个规格项可能存在的规格值
  specIds.forEach((currentSpecId, index) => {
    // 记录符合条件的sku中出现的规格值Id
    const skuSpecItems = []

    // 筛选符合条件的sku
    skus.forEach(sku => {
      // 遍历所有sku，如果该sku的当前规格项中有该规格值，就说该规格项的此规格值是可选的
      let isAvaiSku = specIds.every((specId, idx) => {
        // 只对比其他规格项，不与当前规格项比较
        if (currentSpecId == specId) return true
        // 该规格项没选，或者选择的该规格项的规格值与当前sku对应规格项的规格值相同
        return !checkedSpecItemIds[idx] || checkedSpecItemIds[idx] == sku.sequences[specId]
      })

      // 如果这个sku是符合条件的，则这个sku的该规格项的规格值是可选的
      if (isAvaiSku) {
        skuSpecItems.push(sku.sequences[currentSpecId])
      }
    })
    // 所有可能的规格值和sku中出现过的规格值取交集
    avaiSpecs[index] = intersect(avaiSpecs[index], skuSpecItems)
  })
  // 返回可选规格值组成的二维数组，顺序与规格项顺序一致
  return avaiSpecs
}
function getAftAvaiServiceSpec(params) {
  if (!params || !Array.isArray(params.checkedSpecItemIds) || !Array.isArray(params.skus) || !Array.isArray(params.specIds)) {
    return
  }
  const { checkedSpecItemIds, skus, specIds } = params;
  const size = specIds.length
  const result = new Array(size)
  for (var i = 0; i < size; i++) result[i] = []
  skus.forEach(sku => {
    if (checkedSpecItemIds[0] == sku.sequences[specIds[0]]) {
      const skuSeq = sku.sequences
      Object.entries(skuSeq).forEach(([key, value]) => {
        if(key>1){
          if(skuSeq[key-1]==checkedSpecItemIds[key-1]){
            if (!result[key]) {
              result[key] = [value];
            } else if (!result[key].includes(value)) {
              result[key].push(value);
            }
          }

        }else{
          if (!result[key]) {
            result[key] = [value];
          } else if (!result[key].includes(value)) {
            result[key].push(value);
          }
        }
      });
    }
  });
  return result;
}

export default getAvaiSpecs
